import React, { useMemo } from 'react';
import { useMapSettings } from 'ff/debrief/hooks';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MenuItem from '@mui/material/MenuItem';
import {
    AccordionSetting,
    AccordionSettingDetail,
    AccordionSettingSummary,
    AccordionSummaryValue,
    CustomMenuItem,
    SettingCheckbox,
    SettingLabel,
    SettingSubHeader,
} from 'ff/debrief/components/map/settings/shared';

export const AirportMapSettings = () => {
    const {
        currentSettings,
        settingsUI,
        toggleAccordion,
        toggleShowAirports,
        toggleAirportType,
    } = useMapSettings();

    const airportSettings =
        typeof currentSettings?.filters?.airports === 'boolean'
            ? {
                  heliports: false,
                  private: false,
                  seaplane: false,
                  other: false,
              }
            : currentSettings?.filters?.airports;

    const airportValue = useMemo(() => {
        if (!currentSettings?.airports) {
            return 'Off';
        }
        const airportOptions = currentSettings?.filters?.airports;
        const isAll =
            currentSettings?.airports &&
            airportOptions?.heliports &&
            airportOptions?.private &&
            airportOptions?.seaplane &&
            airportOptions?.other;

        return isAll ? 'All' : 'Custom';
    }, [currentSettings?.airports, currentSettings?.filters?.airports]);

    return (
        <CustomMenuItem>
            <AccordionSetting
                expanded={settingsUI?.accordionsExpanded?.airports}
                onChange={() => toggleAccordion('airports')}
            >
                <AccordionSettingSummary expandIcon={<ExpandMoreIcon />}>
                    <SettingLabel>Airports</SettingLabel>
                    <AccordionSummaryValue>
                        {airportValue}
                    </AccordionSummaryValue>
                </AccordionSettingSummary>
                <AccordionSettingDetail>
                    <MenuItem>
                        <SettingCheckbox
                            id="showAirports"
                            displayName="Show Airports"
                            checked={currentSettings?.airports}
                            onChange={() => toggleShowAirports()}
                        />
                    </MenuItem>
                    <SettingSubHeader>Customize Airports</SettingSubHeader>
                    <MenuItem>
                        <SettingCheckbox
                            displayName="Heliports"
                            checked={airportSettings?.heliports}
                            onChange={() => toggleAirportType('heliports')}
                        />
                    </MenuItem>
                    <MenuItem>
                        <SettingCheckbox
                            displayName="Seaplane"
                            checked={airportSettings?.seaplane}
                            onChange={() => toggleAirportType('seaplane')}
                        />
                    </MenuItem>
                    <MenuItem>
                        <SettingCheckbox
                            displayName="Private"
                            checked={airportSettings?.private}
                            onChange={() => toggleAirportType('private')}
                        />
                    </MenuItem>
                    <MenuItem>
                        <SettingCheckbox
                            id="showOtherAirports"
                            displayName="Other"
                            checked={airportSettings?.other}
                            onChange={() => toggleAirportType('other')}
                        />
                    </MenuItem>
                </AccordionSettingDetail>
            </AccordionSetting>
        </CustomMenuItem>
    );
};
